import { CAMPAIGN_BRIEF_STAGES, CampaignBriefStage } from "../lib/campaignBriefStage";
import styles from "./CampaignBriefStageTabs.module.scss";

type CampaignBriefStageTabsProps = {
  activeStage: CampaignBriefStage;
  onStageChange: (stage: CampaignBriefStage) => void;
  reviewingCount: number;
  shortlistedCount: number;
  purchasedCount: number;
};

export function CampaignBriefStageTabs({
  activeStage,
  onStageChange,
  reviewingCount,
  shortlistedCount,
  purchasedCount,
}: CampaignBriefStageTabsProps) {
  const counts: Record<CampaignBriefStage, number> = {
    [CampaignBriefStage.Reviewing]: reviewingCount,
    [CampaignBriefStage.Shortlisted]: shortlistedCount,
    [CampaignBriefStage.Purchased]: purchasedCount,
  };

  return (
    <nav className={styles.pipeline} aria-label="Brief pipeline">
      {CAMPAIGN_BRIEF_STAGES.map((stage) => {
        const isActive = activeStage === stage.id;
        return (
          <button
            key={stage.id}
            type="button"
            onClick={() => onStageChange(stage.id)}
            aria-current={isActive ? "step" : undefined}
            className={`${styles.step} ${isActive ? styles.stepActive : ""}`}
          >
            <span className={styles.stepIndex}>Step {stage.step}</span>
            <span className={styles.stepBody}>
              <span className={styles.stepLabel}>{stage.label}</span>
              <span className={styles.stepCount}>{counts[stage.id]}</span>
            </span>
          </button>
        );
      })}
    </nav>
  );
}
